import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Avatar, Popover, Modal, message, Button } from "antd";
import { userSignOut, changePassword, updateUserConfigurations, FETCH_USER_CONFIGURATIONS } from "../../appRedux/actions/Auth";
import { showModal, hideModal, submitStart } from "../../appRedux/actions/userModalActions";
import ChangePasswordModal from "../Admin/ChangePasswordModal";
import { modalTypes } from "../../constants/constants";
import { unlockVisitAPI } from '../../../src/services/locked-visits-service'
import { UNSAVED_CHANGES_CONFIRM_TEXT, CONFIRM_TEXT } from "../../constants/messages";
import { history } from "../../appRedux/store";
import InstallerModal from "../../components/common/InstallerModal";
import UserConfigurationsModal from "../UserConfigurationsModal";
import { resetAuthenticatorQrAPI } from "../../services/dashboard-service";


const { confirm } = Modal

class UserProfile extends Component {
  state = {
    visible: false,
    loading: false,
    formData: {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    },
    menuVisible: false,
    confirmVisible: false
  }


  handleOpen = (type) => {

    this.setState({
      menuVisible: false
    }, () => {
      this.props.showModal(type, null);
    })

  }

  handleOpenInstaller = () => {
    this.props.showInstallerModal();
  }

  handleClose = () => {
    this.props.hideModal();
  }


  handleOk = (user) => {
    if (!this.state.loading) {
      this.setState({
        loading: true
      })
      let userData = {
        ...user,
        currentPassword: window.btoa(user.currentPassword),
        newPassword: window.btoa(user.newPassword)
      }
      this.props.changePassword(userData);
      setTimeout(() => {
        this.setState({ loading: false });
      }, 3000);
    }
  }

  handleInstallerOk = () => {

  }

  handleLogout = () => {
    const { unsavedChanges, selectedVisit } = this.props;
    const { isVisitLocked, reportId } = selectedVisit;
    let that = this;
    this.setState({
      menuVisible: false
    }, () => {
      if (unsavedChanges) {

        confirm({
          title: UNSAVED_CHANGES_CONFIRM_TEXT,
          async onOk() {
            if (reportId !== null) {
              let result = await unlockVisitAPI(reportId);
              if (result.success) {
                await that.props.userSignOut()
              }
            }
            that.props.userSignOut()
          },
          onCancel() {
            // Cancel
          }
        })
      } else if (isVisitLocked) {
        confirm({
          title: CONFIRM_TEXT,
          async onOk() {

            if (reportId !== null) {
              let result = await unlockVisitAPI(reportId);
              if (result.success) {
                await that.props.userSignOut()
              } else if (result.error == "Visit is not in locked state!") {
                await that.props.userSignOut()
              }
            } else {
              await that.props.userSignOut()
            }
          },
          onCancel() {
            // Cancel
          }
        })
      } else {
        this.props.userSignOut();
      }
    })
  }

  handleSwitchRole = () => {
    this.setState({ menuVisible: false }, () => {
      history.push({
        pathname: '/user-role-selection',
      });
    });

  }

  handleVisibleChange = visible => {
    this.setState({ menuVisible: visible });
  };

  // method to reset the QR code
  handleReset = async (userId) => {
    try {
      this.setState({
        loading: true,
        confirmVisible: false
      });
      const response = await resetAuthenticatorQrAPI(userId);
      if (response.success) {
        message.success("Authenticator QR code has been reset successfully.");
      } else {
        message.error("Failed to reset Authenticator QR code.");
      }
    } catch (error) {
      message.error("Failed to reset Authenticator QR code.");
    } finally {
      this.setState({
        loading: false
      })
    }
  };

  render() {
    const { authUser, configurations, modal, installerModal } = this.props;
    const { visible, submitting, type, data } = modal;
    const userMenuOptions = (
      <ul className="gx-user-popover">
        {
          authUser && authUser.roles.length > 1 &&
          <li style={{width: "100%"}} onClick={this.handleSwitchRole}>Switch Role</li>
        }
        {authUser && authUser.role !== 'ROLE_ADMIN' &&
          <li style={{width: "100%"}} onClick={() => this.handleOpen("Installer")}>Installer </li>
        }
        {authUser && authUser.role === 'ROLE_MIS' &&
          <li style={{width: "100%"}} onClick={() => this.handleOpen("Default Configurations")}>Default Configurations</li>
        }
        <li style={{width: "100%"}} onClick={() => this.handleOpen('Change Password')}>Change Password</li>
        <li style={{width: "100%"}} onClick={() => this.setState({ confirmVisible: true })}>Reset Auth QR</li>
        <li style={{width: "100%"}} onClick={this.handleLogout}>Log out
        </li>
      </ul>
    );
    var initials = authUser && authUser.firstName ? authUser.firstName.charAt(0).toUpperCase() +
      authUser.lastName.charAt(0).toUpperCase() : '';
    return (

      <div className="gx-flex-row gx-align-items-center gx-mb-1 gx-avatar-row">
        {
          visible && type === 'Change Password' && authUser && (!authUser.changePasswordAtLogon) ?
            <ChangePasswordModal
              email={authUser.email}
              visible={visible}
              submitting={submitting}
              onOk={this.handleOk}
              formData={this.state.formData}
              onCancel={this.handleClose}
            />
            : <React.Fragment />
        }
         {
          visible && type === 'Default Configurations'?
            <UserConfigurationsModal
              visible={visible}
              submitting={submitting}
              onOk={this.props.updateUserConfigurations}
              authUser={authUser}
              configurations={configurations}
              fetchConfigurations={this.props.fetchUserConfigurations}
              formData={this.state.formData}
              onCancel={this.handleClose}
            />
            : <React.Fragment />
        }
        {
          visible && type === 'Installer' && authUser ?
            <InstallerModal
              visible={visible}
              submitting={submitting}
              onOk={this.handleOk}
              authUser={this.props.authUser}
              onCancel={this.handleClose}
            />
            : <React.Fragment />
        }
        <Modal
          title="Reset Authenticator QR"
          visible={this.state.confirmVisible}
          bodyStyle={{ padding: "0px 24px" }}
          onCancel={() => this.setState({ confirmVisible: false })}
          footer={[ 
            <Button key="cancel" style={{ margin: 0 }} onClick={() => this.setState({ confirmVisible: false })}>
              No, Cancel 
            </Button>,
            <Button
              key="confirm"
              type="primary"
              danger
              loading={this.state.loading}
              onClick={() => this.handleReset(authUser.userId)}
            >
              Yes, Reset
            </Button>,
          ]}
        >
          <p>
            Clicking the button below will reset your authenticator setup. You
            will be asked to scan a new QR code the next time you Sign in. Would
            you like to continue?
          </p>
        </Modal>
        <Popover
          placement="bottomRight"
          content={userMenuOptions}
          trigger="click"
          visible={this.state.menuVisible}
          onVisibleChange={this.handleVisibleChange}
        >
          {/* <Avatar src='https://via.placeholder.com/150x150'
            className="gx-size-40 gx-pointer gx-mr-3" alt="" /> */}
          <Avatar className="gx-size-40 gx-pointer" style={{ verticalAlign: 'middle', marginLeft: '-8px' }} size="large">
            {initials ? initials : ""}
          </Avatar>
          <div className="text-ellipse">
            <span className="gx-avatar-name" style={{ fontSize: '13px', }}>{authUser ? authUser.firstName + " " + authUser.lastName : "Loading"}
              <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" /></span>
          </div>
          <p className="gx-sm-0 gx-fs-sm sidebar-email" style={{ marginTop: '-12px' }}>{authUser && authUser.email ? authUser.email : 'NA'}</p>
        </Popover>
      </div>

    )

  }
}

export const mapDispatchToProps = dispatch => ({
  changePassword: bindActionCreators(changePassword, dispatch),
  showModal: bindActionCreators(showModal, dispatch),
  hideModal: bindActionCreators(hideModal, dispatch),
  userSignOut: bindActionCreators(userSignOut, dispatch),
  submitStart: bindActionCreators(submitStart, dispatch),
  updateUserConfigurations: bindActionCreators(updateUserConfigurations, dispatch),
  fetchUserConfigurations: () => dispatch({ type: FETCH_USER_CONFIGURATIONS })
});

const mapStateToProps = ({ activity, auth, modal, installerModal }) => {
  const { authUser, configurations } = auth;
  const { unsavedChanges, selectedVisit } = activity;
  return {
    authUser,
    configurations,
    unsavedChanges,
    modal: modal,
    selectedVisit,
    installerModal
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
